import "@fontsource/inter/200.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { api, authApi } from "./api/axios";
import * as Sentry from "@sentry/react";
import App from "./App";
import { initAmplitude } from "./analytics/amplitude";


Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  tracesSampleRate: 1.0,
  autoSessionTracking: false, // GlitchTip does not support sessions
});


// Initialize Amplitude + Session Replay at module load (NOT inside a React
// effect) so the SDK and the window.__amplitudeAnalytics bridge are ready
// before any Module Federation remote (sophos/helios) fires an event.
// Matches the proven cf.coredesk.client pattern.
initAmplitude();


async function bootstrap() {
  const { registerSharedInterceptors } = await import("./api/registerSharedInterceptors");
  registerSharedInterceptors([api, authApi]);

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
bootstrap();
